import { userContext } from '../userManager';

export const apiAddressDelete = (addressId) =>
  userContext.apiCall({ url: `/addresses/${addressId}`, method: 'DELETE', noResBody: true });

export const apiAddressPatch = (
  addressId,
  { name, address, streetName, postCode, city, province, countryId, isResidential }
) => {
  const body = {
    addressType: name,
    streetName: address ?? streetName,
    region: province,
    postCode,
    city,
    province,
    countryId,
    isResidential,
  };
  return userContext.apiCall({ url: `/addresses/${addressId}`, method: 'PATCH', body });
};
